import React, {Component} from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'
import CopyToClipboard from 'react-copy-to-clipboard'
import {notify} from 'react-notify-toast'
import {Element} from 'react-scroll'
import BackOfficeUserDetailVehicleForm from '../components/BackOfficeUserDetailVehicleForm'
import '../components/BackOfficeUserDetailsModalComponent.css'
import './BackOfficeUserDetailScreen.css'
import BackOfficeUserDetailMarkForm from '../components/BackOfficeUserDetailMarkForm'
import BackOfficeUserDetailParkingPassForm from '../components/BackOfficeUserDetailParkingPassForm'
import BackOfficeUserDetailCreateReceiptComponent from '../components/BackOfficeUserDetailCreateReceiptComponent'
import BackOfficeUserDetailVehicleEditForm from '../components/BackOfficeUserDetailVehicleEditForm'
import classNames from 'classnames'
import BackofficeDocumentsReviewContainer from '../components/BackofficeDocumentsReview/BackofficeDocumentsReviewContainer'
import BackOfficeUserDetailEditMarkForm from '../components/BackOfficeUserDetailEditMarkForm'
import BackOfficeUserDetailLogsTableContainer from '../containers/BackOfficeUserDetailLogsTableContainer'
import BackOfficeUserDetailVehicleLogsContainer from '../containers/BackOfficeUserDetailVehicleLogsContainer'
import BackOfficeUserDetailMarkLogsContainer from '../containers/BackOfficeUserDetailMarkLogsContainer'
import {AdjustemntAlert} from '../components/Alert/AdjustemntAlert'
import {MergeAlert} from '../components/Alert/MergeAlert'
import {WaitingListAlert} from "../components/Alert/WaitingListAlert";

export default class BackOfficeUserDetailScreen extends Component {
  static propTypes = {
    onMarkShortLinkClick: PropTypes.func.isRequired,
    onVehicleShortLinkClick: PropTypes.func.isRequired,
    onMarkRenew: PropTypes.func.isRequired,
    highlightObjects: PropTypes.array.isRequired,
    findObjectById: PropTypes.func.isRequired,
    onRenewPaymentMethodChange: PropTypes.func.isRequired,
    onRenewMarkClick: PropTypes.func.isRequired,
    onCancelRenewMarkClick: PropTypes.func.isRequired,
    markRenewing: PropTypes.object.isRequired,
    markRenewingErrors: PropTypes.object.isRequired,
    renewPaymentMethodSelected: PropTypes.string,
    userAdjustment: PropTypes.object,
    onAdjustmentPay: PropTypes.func,
    onPayWaitingListParkTicket: PropTypes.func,
    onAdjustmentDownloadReceipt: PropTypes.func,
    userWaitingLists: PropTypes.array
  }

  constructor (props) {
    super(props)
    this.state = {
      showCreateVehicle: false,
      showCreateMark: false,
      showCreateParkingPass: false,
      showCreateReceipt: false,
      markEditing: {},
      vehicleEditing: {},
      vehicleDeleting: {},
      marksCeasing: {},
      marksDeleting: {},
      marksDenyingApprovation: {},
      marksDenyingApprovationReasons: {},
      marksListingInWait: {},
      marksListingInWaitInstructions: {},
      showUserLogs: false,
      marksApprovations: {}
    }

    this.onMarkApprovationCircolazioneChange = this.onMarkApprovationCircolazioneChange.bind(this)
    this.onMarkApprovationPeriodoChange = this.onMarkApprovationPeriodoChange.bind(this)
    this.onMarkApprovationSostaChange = this.onMarkApprovationSostaChange.bind(this)
  }

  onMarkApprovationCircolazioneChange (id, value) {
    if (!this.state.marksApprovations[id]) {
      this.setState({
        marksApprovations: {
          ...this.state.marksApprovations,
          [id]: {
            circolazione: value
          }
        }
      })
    } else {
      this.setState({
        marksApprovations: {
          ...this.state.marksApprovations,
          [id]: {
            ...this.state.marksApprovations[id],
            circolazione: value
          }
        }
      })
    }
  }

  onMarkApprovationPeriodoChange (id, value) {
    if (!this.state.marksApprovations[id]) {
      this.setState({
        marksApprovations: {
          ...this.state.marksApprovations,
          [id]: {
            periodo: value
          }
        }
      })
    } else {
      this.setState({
        marksApprovations: {
          ...this.state.marksApprovations,
          [id]: {
            ...this.state.marksApprovations[id],
            periodo: value
          }
        }
      })
    }
  }

  onMarkApprovationSostaChange (id, value) {
    if (!this.state.marksApprovations[id]) {
      this.setState({
        marksApprovations: {
          ...this.state.marksApprovations,
          [id]: {
            sosta: value
          }
        }
      })
    } else {
      this.setState({
        marksApprovations: {
          ...this.state.marksApprovations,
          [id]: {
            ...this.state.marksApprovations[id],
            sosta: value
          }
        }
      })
    }
  }

  onVehicleEditClick (vehicle) {
    let vehiclesEditing = {}
    vehiclesEditing[vehicle.id] = true
    this.setState({vehicleEditing: vehiclesEditing})
  }

  onCloseVehicleEdit () {
    this.setState({vehicleEditing: {}})
    this.props.onCloseVehicleEdit()
  }

  onDeleteVehicleClick (vehicle) {
    let vehiclesDeleting = {}
    vehiclesDeleting[vehicle.id] = true
    this.setState({vehicleDeleting: vehiclesDeleting})
  }

  onCancelDeleteVehicleClick () {
    this.setState({vehicleDeleting: {}})
  }

  onDeleteMarklick (mark) {
    let markDeleting = {}
    markDeleting[mark.id] = true
    this.setState({marksDeleting: markDeleting, marksCeasing: {}})
  }

  onCancelDeleteMarkClick () {
    this.setState({marksDeleting: {}})
  }

  onCloseMarkCease () {
    this.setState({marksCeasing: {}})
    this.props.onCloseMarkCease()
  }

  onCeaseMarklick (mark) {
    let markCeasing = {}
    markCeasing[mark.id] = true
    this.setState({marksCeasing: markCeasing, marksDeleting: {}})
  }

  onEditMarkClick (mark) {
    let markEditing = {}
    markEditing[mark.id] = true
    this.setState({markEditing: markEditing, marksDeleting: {}})
  }

  onCancelEditMarkClick (mark) {
    this.setState({markEditing: {}})
  }

  onCeaseMark (mark) {
    this.props.onCeaseMark(mark)
    this.setState({marksCeasing: {}})
  }

  onCancelCeaseMarkClick () {
    this.setState({marksCeasing: {}})
  }

  onVehicleCancelEditClick (vehicle) {
    let vehiclesEditing = this.state.vehicleEditing
    vehiclesEditing[vehicle.id] = false
    this.setState({vehicleEditing: vehiclesEditing})
  }

  onShowCreateVehicleClick () {
    this.setState({showCreateVehicle: true})
  }

  onHideCreateVehicleClick () {
    this.setState({showCreateVehicle: false})
  }

  onShowCreateMarkClick () {
    this.setState({showCreateMark: true})
  }

  onHideCreateMarkClick () {
    this.setState({showCreateMark: false})
  }

  onShowCreateParkingPassClick () {
    this.setState({showCreateParkingPass: true})
  }

  onHideCreateParkingPassClick () {
    this.setState({showCreateParkingPass: false})
  }

  onShowCreateReceiptClick () {
    this.setState({showCreateReceipt: true})
  }

  onHideCreateReceiptClick () {
    this.setState({showCreateReceipt: false})
  }

  onShowDenyMarkActivation (mark) {
    let marksDenyingApprovation = {}
    let marksDenyingApprovationReasons = {}
    marksDenyingApprovation[mark.id] = true
    marksDenyingApprovationReasons[mark.id] = ''
    this.setState({
      marksDenyingApprovation: marksDenyingApprovation,
      marksDenyingApprovationReasons: marksDenyingApprovationReasons
    })
  }

  onShowListAsWaitMark (mark) {
    let marksListingInWait = {}
    let marksListingInWaitInstructions = {}
    marksListingInWait[mark.id] = true
    marksListingInWaitInstructions[mark.id] = ''
    this.setState({
      marksListingInWait: marksListingInWait,
      marksListingInWaitInstructions: marksListingInWaitInstructions
    })
  }

  onHideListAsWaitMark (mark) {
    let marksListingInWait = {}
    let marksListingInWaitInstructions = {}
    marksListingInWait[mark.id] = false
    marksListingInWaitInstructions[mark.id] = ''
    this.setState({
      marksListingInWait: marksListingInWait,
      marksListingInWaitInstructions: marksListingInWaitInstructions
    })
  }

  onListAsWaitInstructionsChange (event, mark) {
    let marksListingInWaitInstructions = {}
    marksListingInWaitInstructions[mark.id] = event.target.value
    this.setState({marksListingInWaitInstructions: marksListingInWaitInstructions})
  }

  onHideDenyMarkActivation (mark) {
    let marksDenyingApprovation = {}
    let marksDenyingApprovationReasons = {}
    marksDenyingApprovation[mark.id] = false
    marksDenyingApprovationReasons[mark.id] = ''
    this.setState({
      marksDenyingApprovation: marksDenyingApprovation,
      marksDenyingApprovationReasons: marksDenyingApprovationReasons
    })
  }

  onDenyMarkActivationNoteChange (event, mark) {
    let marksDenyingApprovationReasons = {}
    marksDenyingApprovationReasons[mark.id] = event.target.value
    this.setState({marksDenyingApprovationReasons: marksDenyingApprovationReasons})
  }

  isUserBelongsToCategory (categoryId) {
    if (!this.props.user.categories) {
      return false
    }

    let filtered = this.props.user.categories.filter(item => {
      return item.id === categoryId
    })

    return filtered.length > 0
  }

  async onMarkRenew (mark) {
    const markRenewResponse = await this.props.onMarkRenew(mark)
  }

  render () {
    let birthDate = moment(this.props.user.birthDate)
    let birthDateRegistry
    if (this.props.registry.bornDate) {
      birthDateRegistry = moment(this.props.registry.bornDate)
    }

    const {
      onMarkShortLinkClick,
      highlightObjects,
      onVehicleShortLinkClick,
      findObjectById
    } = this.props

    return (<div className="panel panel-default">
      <div className="userDetailModal" style={{padding: '15px'}}>
        {this.props.user && this.props.user.archived && (
          <div className="alert alert-danger">
            <strong>ATTENZIONE!</strong> Questo utente è stato archiviato e non è più utilizzabile.<br />
            Qualunque operazione su questo utente non avrà alcun effetto.
          </div>
        )}
        <div className="block-info">
          <div className="row">
            <div className="col-md-2">
              {this.props.user && <div className="square-box">
                <span className="glyphicon glyphicon-user glyphicon-lg">{}</span>
              </div>}
            </div>
            <div className="col-md-10">
              {this.props.user && <div className="dataUser media-body">
                <h3 className="title-green">
                  {this.props.user.firstName + ' ' + this.props.user.lastName}
                  <button type="button" className="btn btn-info-user" onClick={this.props.onEditProfileClick}>
                    <i className="glyphicon glyphicon-cog">{}</i> Modifica Utente
                  </button>
                  <button type="button" className="btn btn-info-user" onClick={() => this.props.onDownloadUserCredentials(this.props.user)}>
                    <i className="glyphicon glyphicon-download">{}</i> Scarica Dati Utente
                  </button>
                </h3>
                {this.props.user.fiscalCode && <h5>
                  <strong>Codice Fiscale: </strong>
                  {this.props.user.fiscalCode + ' '}
                  {(this.props.registry.fiscalCode) && <OverlayTrigger placement="right" overlay={<Tooltip id="tt-msg-0">Questo codice fiscale &egrave; presente nell'Anagrafica Residenti</Tooltip>}>
                    <span style={{color: '#006f4a'}} className="glyphicon glyphicon-ok">{}</span>
                  </OverlayTrigger>}
                  {(!this.props.registry.fiscalCode && this.props.user.fiscalCode) && <OverlayTrigger  placement="right" overlay={<Tooltip id="tt-msg-1">Attenzione! Questo codice fiscale non ha alcuna corrispondenza in Anagrafica Residenti</Tooltip>}>
                    <span style={{color: '#d9534f'}} className="glyphicon glyphicon-remove">{}</span>
                  </OverlayTrigger>}
                </h5>}
                {this.props.user.firstName && <h5>
                  <strong>Nome: </strong>
                  {this.props.user.firstName + ' '}
                  {(this.props.registry.firstName && this.props.registry.firstName.toUpperCase() === this.props.user.firstName.toUpperCase()) && <OverlayTrigger placement="right" overlay={
                    <Tooltip>Il nome in Anagrafica Residenti corrisponde a quello dichiarato in fase di registrazione</Tooltip>}>
                    <span style={{color: '#006f4a'}} className="glyphicon glyphicon-ok">{}</span>
                  </OverlayTrigger>}
                  {(this.props.registry.firstName && this.props.registry.firstName.toUpperCase() !== this.props.user.firstName.toUpperCase()) && <OverlayTrigger placement="right" overlay={
                    <Tooltip>Il nome in Anagrafica Residenti <strong>NON</strong> corrisponde a quello dichiarato in fase di registrazione: <br /><strong>{this.props.registry.firstName}</strong></Tooltip>}>
                    <CopyToClipboard text={this.props.registry.firstName}
                                     onCopy={() => notify.show('"' + this.props.registry.firstName + '" copiato.', 'custom', 2000, {background: '#333', text: 'white'})}>
                      <span style={{color: '#d9534f'}} className="glyphicon glyphicon-remove">{}</span>
                    </CopyToClipboard>
                  </OverlayTrigger>}
                </h5>}
                {this.props.user.lastName && <h5>
                  <strong>Cognome: </strong>
                  {this.props.user.lastName + ' '}
                  {(this.props.registry.lastName && this.props.registry.lastName.toUpperCase() === this.props.user.lastName.toUpperCase()) && <OverlayTrigger placement="right" overlay={
                    <Tooltip>Il Cognome in Anagrafica Residenti corrisponde a quello dichiarato in fase di registrazione</Tooltip>}>
                    <span style={{color: '#006f4a'}} className="glyphicon glyphicon-ok">{}</span>
                  </OverlayTrigger>}
                  {(this.props.registry.lastName && this.props.registry.lastName.toUpperCase() !== this.props.user.lastName.toUpperCase()) && <OverlayTrigger placement="right" overlay={
                    <Tooltip>Il Cognome in Anagrafica Residenti <strong>NON</strong> corrisponde a quello dichiarato in fase di registrazione: <br /><strong>{this.props.registry.lastName}</strong></Tooltip>}>
                    <CopyToClipboard text={this.props.registry.lastName}
                                     onCopy={() => notify.show('"' + this.props.registry.lastName + '" copiato.', 'custom', 2000, {background: '#333', text: 'white'})}>
                      <span style={{color: '#d9534f'}} className="glyphicon glyphicon-remove">{}</span>
                    </CopyToClipboard>
                  </OverlayTrigger>}
                </h5>}
                {this.props.user.birthDate && <h5>
                  <strong>Data di nascita: </strong>
                  {birthDate.format('L') + ' '}
                  {(this.props.registry.bornDate && birthDate.isSame(birthDateRegistry, 'day')) && <OverlayTrigger placement="right" overlay={
                    <Tooltip>La data di nascita in Anagrafica Residenti corrisponde a quella dichiarata in fase di registrazione</Tooltip>}>
                    <span style={{color: '#006f4a'}} className="glyphicon glyphicon-ok">{}</span>
                  </OverlayTrigger>}
                  {(this.props.registry.bornDate && !birthDate.isSame(this.props.registry.bornDate, 'day')) && <OverlayTrigger placement="right" overlay={
                    <Tooltip>La data di nascita in Anagrafica Residenti <strong>NON</strong> corrisponde a quella dichiarata in fase di registrazione: <br /><strong>{birthDateRegistry.format('L')}</strong></Tooltip>}>
                    <CopyToClipboard text={birthDateRegistry.format('L')}
                                     onCopy={() => notify.show('"' + birthDateRegistry.format('L') + '" copiato.', 'custom', 2000, {background: '#333', text: 'white'})}>
                      <span style={{color: '#d9534f'}} className="glyphicon glyphicon-remove">{}</span>
                    </CopyToClipboard>
                  </OverlayTrigger>}
                </h5>}

                {this.props.user.birthPlace && <h5>
                  <strong>Luogo di nascita: </strong>
                  {this.props.user.birthPlace + ' '}
                  <OverlayTrigger placement="right" overlay={
                    <Tooltip>Luogo di nascita presente in Anagrafica Residenti:<br /> <strong>{this.props.registry.bornPlace}</strong></Tooltip>}>
                    <CopyToClipboard text={this.props.registry.bornPlace}
                                     onCopy={() => notify.show('"' + this.props.registry.bornPlace + '" copiato.', 'custom', 2000, {background: '#333', text: 'white'})}>
                      <span style={{color: '#006f4a'}} className="glyphicon glyphicon-pushpin">{}</span>
                    </CopyToClipboard>
                  </OverlayTrigger>
                </h5>}
                {this.props.user.sex && <h5><strong>Sesso:</strong> {this.props.user.sex}</h5>}
                {this.props.user.residenceAddress && <h5>
                  <strong>Indirizzo di residenza:</strong>{' '}
                  {this.props.user.residenceAddress + ', ' + this.props.user.residenceCivicNumber}
                </h5>}
                {this.props.user.residenceArea && <h5>
                  <strong>Area di residenza:</strong>{' '}
                  {this.props.user.residenceArea.code}
                </h5>}
                {this.props.user.parkSpaceAddress && (
                  <h5><strong>Indirizzo Posto Auto: </strong> {this.props.user.parkSpaceAddress.name}</h5>
                )}
                {this.props.user.companyName && <h5>
                  <strong>Azienda di appartenenza:</strong> {this.props.user.companyName}
                </h5>}
                {
                  (this.props.user.workAddress) && <h5><strong>Sede Azienda: </strong>
                    {this.props.user.workAddress}
                    {this.props.user.workCivicNumber && ', ' + this.props.user.workCivicNumber}
                    {this.props.user.workCity && ', ' + this.props.user.workCity}
                    {this.props.user.workCap && ' - ' + this.props.user.workCap}</h5>
                }
                {this.props.user.workArea && <h5><strong>Area di lavoro:</strong> {this.props.user.workArea.code}</h5>}
                {this.props.user.vatNumber && <h5><strong>Partita IVA:</strong> {this.props.user.vatNumber}</h5>}
                {this.props.user.phone && <h5><strong>Telefono:</strong> {this.props.user.phone}</h5>}
                {this.props.user.email && <h5><strong>Email:</strong> {this.props.user.email}</h5>}

              </div>}
            </div>
            <div style={{marginTop: '20px'}} className="col-md-6 col-md-offset-2">
              {(this.props.user.categories && this.props.user.categories.length > 0) && <div className="dataUser">
                <h4>Categorie di questo Utente: </h4>
                {this.props.user.categories.map(item => <div key={item.id} className="">
                  <h5 className="green"><i className="glyphicon glyphicon-chevron-right pull-left">{}</i> <strong>{item.label.charAt(0).toUpperCase() + item.label.slice(1)}</strong></h5>
                  <h5>{item.description.charAt(0).toUpperCase() + item.description.slice(1)}</h5>
                </div>)}
              </div>}
            </div>

            <div className="col-md-10 col-md-offset-2">
              {!this.state.showUserLogs && (
                <button
                  onClick={() => this.setState({showUserLogs: true})}
                  type="button"
                  style={{marginTop: '10px'}}
                  className="btn btn-success btn-xs btn-update btn-add-card">
                  Mostra Log Utente
                </button>
              )}
              {(this.props.user && this.props.user.id && this.state.showUserLogs) && (
                <div>
                  <BackOfficeUserDetailLogsTableContainer
                    userId={ parseInt(this.props.user.id)}
                  />
                  <button
                    onClick={() => this.setState({showUserLogs: false})}
                    type="button"
                    className="btn btn-xs btn-update btn-add-card">
                    Nascondi Log Utente
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {(this.props.userWaitingLists.map((item, index) => {
          return (
            <React.Fragment key={`user-waitinglist-${index}`}>
              <div className="row">
                <div className="col-md-push-2 col-md-6">
                  <WaitingListAlert
                    waitingList={item}
                    onPay={this.props.onPayWaitingListParkTicket}
                  />
                </div>
              </div>
            </React.Fragment>
          )
        }))}

        {this.props.merger && (
          <React.Fragment>
            {this.props.merger.mergeUser !== null && this.props.merger.mergeUser.merged === 0 && (
              <div className="row">
                <div className="col-md-push-2 col-md-6">
                  <MergeAlert
                    loading={this.props.merging}
                    onAccept={this.props.acceptMerge}
                    onDeny={this.props.denyMerge}
                  />
                </div>
              </div>
            )}
          </React.Fragment>
        )}

        {this.props.userAdjustment && (
          <div className="row">
            <div className="col-md-push-2 col-md-6">
              <AdjustemntAlert
                downloadReceipt={this.props.onAdjustmentDownloadReceipt}
                onPay={this.props.onAdjustmentPay}
                isBackOffice
                adjustment={this.props.userAdjustment}
              />
            </div>
          </div>
        )}

        <div className="block-info">
          <div className="row">
            <div className="col-md-2">
              {this.props.user.vehicles && <div className="square-box">
                <span className="glyphicon glyphicon-road glyphicon-lg">{}</span>
              </div>}
            </div>
            <div className="col-md-10">
              <h3 className="title-green">
                Veicoli <span className="margin-span" style={{marginRight: '2rem'}}>{}</span>
                {!this.state.showCreateVehicle && <a className="btn btn-green" onClick={this.onShowCreateVehicleClick.bind(this)}>Nuovo Veicolo</a>}
              </h3>
            </div>
          </div>

          {this.state.showCreateVehicle &&
          <div className="row">
            <div className="static-modal col-md-12">
              <div tabIndex="-1" role="dialog" className="modal my-modal1" style={{display: 'block'}}>
                <div className="modal-dialog" style={{marginTop: '0'}}>
                  <div className="modal-content my-modal2" role="document">
                    <div className="modal-header">
                      <div className="row justify-content-between">
                        <div className="col-md-3">
                          Crea veicolo:
                        </div>
                        <div className="col-md-offset-11 text-center">
                          {this.state.showCreateVehicle &&
                          <a className="glyphicon glyphicon-remove chiudi-btn" onClick={this.onHideCreateVehicleClick.bind(this)}>{}</a>}
                        </div>
                      </div>
                    </div>
                    <div className="modal-body">
                      {this.state.showCreateVehicle && <div className="text-center">
                        <BackOfficeUserDetailVehicleForm
                          loading={this.props.vehicleLoading}
                          vehicleCreateSuccess={this.props.vehicleSuccess}
                          vehicleError={this.props.vehicleError}
                          onSubmit={this.props.onVehicleSubmit} />
                      </div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
        
          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-10">
              <div className="cards-container">
                {this.props.user.vehicles ? this.props.user.vehicles.map(item =>
                  <div key={item.id} className={classNames('col-md-4', {'animated flash': highlightObjects.indexOf(`vehicle-${item.id}`) !== -1})}>
                    <Element name={`vehicle-${item.id}`} />
                    {!this.state.vehicleEditing[item.id] && <div className="card">
                      <OverlayTrigger
                        placement="left"
                        shouldUpdatePosition={true}
                        overlay={
                          <Tooltip id="tt-msg-2">
                            <BackOfficeUserDetailVehicleLogsContainer
                              vehicleId={item.id}
                            />
                          </Tooltip>
                        }
                      >
                        <div className="icon-tooltip-div">
                          <i className="glyphicon glyphicon-info-sign">{}</i>
                        </div>
                      </OverlayTrigger>
                      <div className="caption">
                        <div className="col-md-12">
                          <p style={{fontSize: 13}}>{item.VehicleOwnershipType && item.VehicleOwnershipType.name}</p>
                          <h3 className="text-muted">{item.plate_number}</h3>
                          <p>{item.VehiclePowerSupply && item.VehiclePowerSupply.name}</p>
                        </div>

                        <button onClick={() => this.onVehicleEditClick(item)} type="button" className="btn btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-cog">{}</i> Modifica</button>
                        {!this.state.vehicleDeleting[item.id] && <button onClick={() => this.onDeleteVehicleClick(item)} type="button" className="btn btn-danger btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-trash">{}</i> Elimina</button>}
                        {this.state.vehicleDeleting[item.id] && <div>Sei sicuro di voler eliminare questo veicolo?
                          {this.props.vehiclesDeleteResults[item.id] === 'loading' && <span>Eliminazione del veicolo in corso...</span>}
                          {this.props.vehiclesDeleteResults[item.id] === 'error' && <span>Errore durante l'eliminazione del veicolo</span>}
                          <button type="button" onClick={() => this.props.onDeleteVehicle(item)} className="btn btn-danger btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-trash">{}</i> Elimina Veicolo</button>
                          <button onClick={() => this.onCancelDeleteVehicleClick()} type="button" className="btn btn-default btn-xs btn-update btn-add-card"> Annulla Eliminazione</button>
                        </div>}
                      </div>
                    </div>}
                    {this.state.vehicleEditing[item.id] && <BackOfficeUserDetailVehicleEditForm
                      vehicle={item}
                      onCloseVehicleEdit={this.onCloseVehicleEdit.bind(this)}
                      status={this.props.vehiclesEditsResults[item.id]}
                      initialValues={item}
                      onCancelClick={() => this.onVehicleCancelEditClick(item)}
                      onSubmit={(values) => this.props.onEditVehicleSubmit(values)} />}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        
        

        <div className="block-info">
          <div className="row">
            <div className="col-md-2">
              {this.props.user.marks && <div className="square-box">
                <span className="glyphicon glyphicon-tag glyphicon-lg">{}</span>
              </div>}
            </div>
            <div className="col-md-10">
              <h3 className="title-green">Contrassegni <span className="margin-span" style={{marginRight: '2rem'}} />
                {!this.state.showCreateMark && <a className="btn btn-green" onClick={this.onShowCreateMarkClick.bind(this)}>Nuovo Contrassegno</a>}
              </h3>
            </div>
          </div>

          {this.state.showCreateMark &&
          <div className="row">
            <div className="static-modal col-md-12">
              <div className="my-modal1" style={{display: 'block'}}>
                <div className="modal-dialog" style={{marginTop: '0'}}>
                  <div className="modal-content my-modal2" role="document">
                    <div className="modal-header">
                      <div className="row justify-content-between">
                        <div className="col-md-6">
                          Crea Contrassegno:
                        </div>
                        <div className="col-md-offset-11 text-center">
                          {this.state.showCreateMark && <a className="glyphicon glyphicon-remove chiudi-btn" onClick={this.onHideCreateMarkClick.bind(this)}>{}</a>}
                        </div>
                      </div>
                    </div>
                    <div className="modal-body">
                      {this.state.showCreateMark && <div className="text-center">
                        <BackOfficeUserDetailMarkForm
                          addresses={this.props.addresses}
                          initialValues={{quantity: 1, total: 0}}
                          loading={this.props.markLoading}
                          markSuccess={this.props.markSuccess}
                          markCreateError={this.props.markError}
                          onUserCategorySelected={this.props.onCreateMarkUserCategorySelected}
                          areas={this.props.areas}
                          markTypes={this.props.markTypes}
                          user={this.props.user}
                          onSubmit={this.props.onMarkSubmit}
                        />
                      </div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}

          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-10">
              <div className="cards-container">
                {this.props.user.marks ? this.props.user.marks.map(item => {
                  const fatherMark = item.fatherMark ? findObjectById(item.fatherMark, this.props.user.marks) : null
                  let zonesFiltered
                  if (item.MarkType.fixedAreaId) {
                    zonesFiltered = item.MarkType.Areas.filter(item2 => {
                      return item2.id === item.MarkType.fixedAreaId
                    })
                  } else if (item.Category.parkingInDifferentPlace) {
                    zonesFiltered = item.MarkType.Areas.filter(item2 => {
                      return item2.id === this.props.user.parkSpaceAddress.areaId
                    })
                  } else {
                    zonesFiltered = item.MarkType.Areas.filter(item => {
                      if (this.props.user.residenceArea) {
                        return item.id === this.props.user.residenceArea.id
                      } else if (this.props.user.workArea) {
                        return item.id === this.props.user.workArea.id
                      }
                    })
                  }

                  const markZone = zonesFiltered.length > 0 ? zonesFiltered[0].code : ''

                  return (
                    <div
                      key={`mark-${item.id}`}>
                      {item.active && <div className={classNames('col-md-6', {'animated flash': highlightObjects.indexOf(`mark-${item.id}`) !== -1})}>
                        <Element name={`mark-${item.id}`} />
                        <div className="card-marks">
                          <OverlayTrigger
                            shouldUpdatePosition={true}
                            placement="left"
                            overlay={
                              <Tooltip>
                                <BackOfficeUserDetailMarkLogsContainer
                                  markId={item.id}
                                />
                              </Tooltip>
                            }
                          >
                            <div className="icon-tooltip-div">
                              <i className="glyphicon glyphicon-info-sign">{}</i>
                            </div>
                          </OverlayTrigger>
                          <div className="caption" style={{padding: 10}}>
                            <h5>
                              <strong>{item.MarkType.name + ' ' + item.Category.label.toUpperCase()}</strong>
                              {item.ceased && <span style={{color: 'red', marginLeft: 10}}> CESSATO</span>}
                              {(!item.paid && item.price > 0) && <span style={{color: 'orange', fontWeight: 'bold', marginLeft: 10}}>IN ATTESA DI PAGAMENTO</span>}
                            </h5>
                            {item.fatherMark && (
                              <h5>
                                <strong>Derivato da contrassegno N.: </strong>
                                <a
                                  href="javascript:void(0);"
                                  onClick={() => onMarkShortLinkClick(item)}>
                                  {item.fatherMark}
                                </a>
                              </h5>
                            )}
                            {(item.note && item.ceased) && <h5><strong>Motivo rifiuto:</strong> {item.note}</h5>}
                            <h5>
                              <strong>zona</strong>: {markZone}
                            </h5>
                            <h5><strong>Num identificativo.</strong> {item.id}</h5>
                            <h5>
                              <strong>
                                {`Targ${item.Vehicles.length > 1 ? 'he' : 'a'}: `}
                                {item.Vehicles.map((item, index) => (
                                  <a key={'a-' + index} href="javascript:void(0);" onClick={() => onVehicleShortLinkClick(item)}>{item.plate_number}{' '}</a>
                                ))}
                              </strong>
                            </h5>
                            <h5><strong>Emesso il:</strong> {moment(item.issuedDate).format('L')}</h5>
                            <h5><strong>Valido dal </strong> {moment(item.startDate).format('L')}<strong> al</strong> {moment(item.endDate).format('L')}
                            </h5>
                            {(!this.state.marksDeleting[item.id] && !item.ceased && !this.state.marksCeasing[item.id] && !this.state.markEditing[item.id] && !this.props.markRenewing[item.id] && (moment(item.endDate).startOf('day').diff(moment().startOf('day'), 'days') <= 3 && !item.renewed)) && <button onClick={() => this.props.onRenewMarkClick(item)} type="button" className="btn btn-success btn-xs btn-update btn-add-card">Rinnova</button>}
                            {(!this.state.marksDeleting[item.id] && !item.ceased && !this.state.marksCeasing[item.id] && !this.state.markEditing[item.id] && !this.props.markRenewing[item.id]) && <button onClick={() => this.onEditMarkClick(item)} type="button" className="btn btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-cog">{}</i> Modifica</button>}
                            {(!this.state.marksCeasing[item.id] && !item.ceased && !this.state.markEditing[item.id] && !this.props.markRenewing[item.id]) && <button onClick={() => this.onCeaseMarklick(item)} type="button" className="btn btn-danger btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-ban-circle">{}</i> Cessa</button>}
                            {(!this.state.marksDeleting[item.id] && !this.state.markEditing[item.id] && !this.props.markRenewing[item.id]) && <button onClick={() => this.onDeleteMarklick(item)} type="button" className="btn btn-danger btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-trash">{}</i> Elimina</button>}

                            {this.props.markRenewing[item.id] && (
                              <div>
                                Conferma Rinnovo Contrassegno.<br />
                                <div className="row">
                                  <div className="col-md-12 text-left">
                                    <label>Metodo di Pagamento</label>
                                    <div className="radio">
                                      <label>
                                        <input
                                          type="radio"
                                          value="SPORTELLO_POS"
                                          checked={this.props.renewPaymentMethodSelected === 'SPORTELLO_POS'}
                                          onChange={this.props.onRenewPaymentMethodChange}
                                        /> POS
                                      </label>
                                    </div>
                                    <div className="radio">
                                      <label>
                                        <input
                                          type="radio"
                                          value="SPORTELLO_CONTANTI"
                                          checked={this.props.renewPaymentMethodSelected === 'SPORTELLO_CONTANTI'}
                                          onChange={this.props.onRenewPaymentMethodChange}
                                        /> CONTANTI
                                      </label>
                                    </div>
                                  </div>

                                  {this.props.markRenewingErrors[item.id] && (
                                    <div className="text-danger text-center">
                                      {this.props.markRenewingErrors[item.id]}
                                    </div>
                                  )}
                                </div>
                                <button type="button" onClick={() => this.props.onMarkRenew(item)} className="btn btn-success btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-trash">{}</i> Rinnova</button>
                                <button onClick={() => this.props.onCancelRenewMarkClick()} type="button" className="btn btn-default btn-xs btn-update btn-add-card"> Annulla Rinnovo</button>
                              </div>
                            )}

                            {this.state.markEditing[item.id] && (
                              <div>
                                <BackOfficeUserDetailEditMarkForm
                                  markTypeId={item.MarkType.id}
                                  mark={item}
                                  addresses={this.props.addresses}
                                  initialValues={{
                                    circolazione: item.circolazione,
                                    periodo: item.periodo,
                                    sosta: item.sosta,
                                    ...item.Vehicles.reduce((accumulator, currentValue, currentIndex) => {
                                      return {
                                        ...accumulator,
                                        ['vehicle' + currentIndex]: currentValue.id + ''
                                      }
                                    }, {}),
                                    startAddress: item.startAddressId,
                                    addressRoute: item.route
                                  }}
                                  onCancel={() => this.onCancelEditMarkClick(item)}
                                  loading={this.props.markLoading}
                                  areas={this.props.areas}
                                  user={this.props.user}
                                  area={markZone}
                                  onSubmit={async (values) => {
                                    const result = await this.props.onMarkEditSubmit(values)
                                    this.onCancelEditMarkClick()
                                  }} />
                              </div>
                            )}

                            {this.state.marksCeasing[item.id] && <div>
                              Sei sicuro di voler cessare questo contrassegno?<br />
                              {this.props.markCeaseResults[item.id] === 'loading' && <span>Cessazione del contrassegno in corso...</span>}
                              {this.props.markCeaseResults[item.id] === 'error' && <span>Errore durante la cessazione del contrassegno</span>}
                              {this.props.markCeaseResults[item.id] !== 'success' && <div>
                                <button type="button" onClick={() => this.onCeaseMark(item)} className="btn btn-danger btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-trash">{}</i> Cessa Contrassegno</button>
                                <button onClick={() => this.onCancelCeaseMarkClick()} type="button" className="btn btn-default btn-xs btn-update btn-add-card"> Annulla Cessazione</button>
                              </div>}
                              {this.props.markCeaseResults[item.id] === 'success' && <div>
                                <button type="button" onClick={() => this.onCloseMarkCease()} className="btn btn-danger btn-xs btn-update btn-add-card">Chiudi</button>
                              </div>}
                            </div>}

                            {this.state.marksDeleting[item.id] && <div>
                              Sei sicuro di voler eliminare questo contrassegno?<br />
                              {this.props.markDeleteResults[item.id] === 'loading' && <span>Eliminazione del contrassegno in corso...</span>}
                              {this.props.markDeleteResults[item.id] === 'error' && <span>Errore durante l{"'"}eliminazione del contrassegno</span>}
                              <button type="button" onClick={() => this.props.onDeleteMark(item)} className="btn btn-danger btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-trash">{}</i> Elimina Contrassegno</button>
                              <button onClick={() => this.onCancelDeleteMarkClick()} type="button" className="btn btn-default btn-xs btn-update btn-add-card"> Annulla Eliminazione</button>
                            </div>}

                            {!this.state.markEditing[item.id] && (
                              <div className="button-download">
                                <a onClick={() => this.props.onDownloadMark(item)} className="btn btn-info-user"><i className="glyphicon glyphicon-download">{}</i> Contrassegno</a>
                                <a onClick={() => this.props.onDownloadMarkRelease(item)} className="btn btn-info-user"><i className="glyphicon glyphicon-download">{}</i> Accettazione</a>
                                <a onClick={() => this.props.onMarkReceiptDownload(item)} className="btn btn-info-user"><i className="glyphicon glyphicon-download">{}</i> Ricevuta</a>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>}

                      {!item.active && <div className={classNames('col-md-6', {'animated flash': highlightObjects.indexOf(`mark-${item.id}`) !== -1})}>
                        <div className="card-marks-temporaney">
                          <Element name={`mark-${item.id}`} />
                          <OverlayTrigger
                            placement="left"
                            shouldUpdatePosition={true} 
                            overlay={
                              <Tooltip>
                                <BackOfficeUserDetailMarkLogsContainer
                                  markId={item.id}
                                />
                              </Tooltip>
                            }
                          >
                            <div className="icon-tooltip-div">
                              <i className="glyphicon glyphicon-info-sign">{}</i>
                            </div>
                          </OverlayTrigger>
                          <div className="caption capiton-temporaney" style={{padding: 10}}>
                            <div className="title-marks">
                              {(fatherMark && fatherMark.renewed) ? (
                                <span><strong>RINNOVO</strong> CONTRASSEGNO IN ATTESA DI APPROVAZIONE</span>
                              ) : (
                                `CONTRASSEGNO IN ATTESA DI APPROVAZIONE`
                              )}
                            </div>
                            {item.fatherMark && (
                              <h5>
                                <strong>Derivato da contrassegno N.: </strong>
                                <a
                                  href="javascript:void(0);"
                                  onClick={() => onMarkShortLinkClick(item)}>
                                  {item.fatherMark}
                                </a>
                              </h5>
                            )}
                            <h5><strong>{item.MarkType.name + ' ' + item.Category.label.toUpperCase()}</strong>{item.ceased && <span style={{color: 'red', marginLeft: 10}}> CESSATO</span>}</h5>
                            <h5>
                              <strong>zona</strong>: {markZone}
                            </h5>
                            <h5><strong>Num. identificativo</strong> {item.id}</h5>
                            <h5>
                              <strong>
                                {`Targ${item.Vehicles.length > 1 ? 'he' : 'a'}: `}
                                {item.Vehicles.map((item, index) => (
                                  <a key={'aa-' + index} href="javascript:void(0);" onClick={() => onVehicleShortLinkClick(item)}>{item.plate_number}{' '}</a>
                                ))}
                              </strong>
                            </h5>
                            <h5><strong>Richiesto il:</strong> {moment(item.createdAt).format('L')}</h5>
                            <h5><strong>Prezzo:</strong> € {Number(item.price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h5>
                            <div className="row">
                              <div className="form-group col-md-4">
                                <label>Circolazione</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={this.state.marksApprovations[item.id] ? this.state.marksApprovations[item.id].circolazione : ''}
                                  onChange={(e) => this.onMarkApprovationCircolazioneChange(item.id, e.target.value)}
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Periodo</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={this.state.marksApprovations[item.id] ? this.state.marksApprovations[item.id].periodo : ''}
                                  onChange={(e) => this.onMarkApprovationPeriodoChange(item.id, e.target.value)}
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Sosta</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={this.state.marksApprovations[item.id] ? this.state.marksApprovations[item.id].sosta : ''}
                                  onChange={(e) => this.onMarkApprovationSostaChange(item.id, e.target.value)}
                                />
                              </div>
                            </div>
                            {(item.MarkType.DocumentTypes.length > 0 &&
                              ((fatherMark && !fatherMark.renewed) || !fatherMark)) && (
                              <div style={{marginBottom: '15px'}}>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={(
                                    <Tooltip>
                                      <div style={{padding: '10px', textAlign: 'left'}}>
                                        <div>
                                          Totale documenti richiesti:{' '}
                                          <strong>
                                            {item.documentsReview.totalDocumentsRequested}
                                          </strong>
                                        </div>
                                        <div>
                                          Totale documenti Caricati:{' '}
                                          <strong>
                                            {item.documentsReview.totalDocumentsUploaded}
                                          </strong>
                                        </div>
                                        <div style={{marginBottom: '10px'}}>
                                          Totale documenti Approvati:{' '}
                                          <strong className={classNames({
                                            'text-danger': item.documentsReview.totalDocumentsApproved !== item.documentsReview.totalDocumentsRequested
                                          })}>
                                            {item.documentsReview.totalDocumentsApproved}
                                          </strong>
                                        </div>
                                        {item.documentsReview.documentTypes.map((documentTypeItem, documentTypeIndex) => {
                                          return (
                                            <div key={`mark-${item.id}-documents-review-${documentTypeIndex}`}>
                                              {documentTypeItem.name}:{' '}
                                              {documentTypeItem.documents.length > 0 ? documentTypeItem.documents.map((documentItem, documentIndex) => {
                                                return (
                                                  <span key={`mark-${item.id}-documents-review-${documentTypeIndex}-document-${documentIndex}`}>
                                                  {documentItem.documentApproved ? (
                                                    <span
                                                      style={{color: '#006f4a'}}
                                                      className="glyphicon glyphicon-ok"
                                                    />
                                                  ) : (
                                                    <span
                                                      style={{color: '#d9534f'}}
                                                      className="glyphicon glyphicon-remove" />
                                                  )}
                                                    <br />
                                                </span>
                                                )
                                              }) : (
                                                <span
                                                  style={{color: '#d9534f'}}
                                                  className="glyphicon glyphicon-remove" />
                                              )}
                                            </div>
                                          )
                                        })}
                                      </div>
                                    </Tooltip>
                                  )}
                                >
                                  {
                                    item.documentsReview.totalDocumentsRequested === item.documentsReview.totalDocumentsUploaded &&
                                    item.documentsReview.totalDocumentsApproved === item.documentsReview.totalDocumentsRequested ? (
                                      <span className="text-success">
                                    Verifica dei documenti Completa
                                    <span
                                      style={{color: '#006f4a', marginLeft: '8px', marginRight: '8px'}}
                                      className="glyphicon glyphicon-ok"
                                    />
                                  </span>
                                    ) : (
                                      <span className="text-danger">
                                    Verifica dei documenti necessaria
                                    <span
                                      style={{color: '#d9534f', marginLeft: '8px', marginRight: '8px'}}
                                      className="glyphicon glyphicon-remove" />
                                  </span>
                                    )}
                                </OverlayTrigger>

                                <a
                                  className="btn-file-browser-confirm"
                                  onClick={() => this.props.onOpenReviewDocumentsModal(item)}>
                                  Revisiona Documenti
                                </a>
                                <BackofficeDocumentsReviewContainer
                                  onApprovationChanged={this.props.onApprovationChanged}
                                  userName={this.props.user.firstName + '_' + this.props.user.lastName}
                                  onClose={this.props.onCloseReviewDocumentsModal}
                                  open={this.props.showReviewDocumentsModal}
                                  mark={this.props.reviewingMark}
                                />
                              </div>
                            )}
                            {item.MarkNotes.length > 0 && <div>
                              <h5 className="text-info"><strong>Note di questo contrassegno:</strong></h5>
                              <ul className="list-group">
                                {item.MarkNotes.map((item, index) => <li className="list-group-item" style={{whiteSpace: 'pre-line'}} key={index}>
                                  <small><em>{moment(item.createdAt).fromNow()}</em></small>: <strong>{item.notes}</strong>
                                </li>)}
                              </ul>
                            </div>}

                            {(!this.state.marksDenyingApprovation[item.id] && !this.state.marksListingInWait[item.id]) && <div>
                              <button onClick={() => this.props.onMarkActivateClick({
                                ...item,
                                circolazione: this.state.marksApprovations[item.id] ? this.state.marksApprovations[item.id].circolazione : null,
                                periodo: this.state.marksApprovations[item.id] ? this.state.marksApprovations[item.id].periodo : null,
                                sosta: this.state.marksApprovations[item.id] ? this.state.marksApprovations[item.id].sosta : null
                              })} className="btn btn-success btn-xs btn-update">Attiva Contrassegno</button>
                              <button onClick={() => { this.onShowListAsWaitMark(item) }} className="btn btn-warning btn-xs btn-update">Metti in Attesa</button>
                              <button onClick={() => { this.onShowDenyMarkActivation(item) }} className="btn btn-danger btn-xs btn-update">Nega Attivazione</button>
                            </div>}
                            {this.state.marksDenyingApprovation[item.id] && <div>
                              <input
                                className=""
                                placeholder="Motivazione..."
                                required
                                type="text"
                                value={this.state.marksDenyingApprovationReasons[item.id]}
                                onChange={(event) => this.onDenyMarkActivationNoteChange(event, item)} />
                              <button onClick={() => this.props.onDenyMarkActivationClick(this.state.marksDenyingApprovationReasons[item.id], item)} className="btn btn-danger btn-xs btn-update">Conferma Rifiuto</button>
                              <button onClick={() => { this.onHideDenyMarkActivation(item) }} className="btn btn-xs btn-update">Annulla</button>
                            </div>}
                            {this.state.marksListingInWait[item.id] && <div>
                            <textarea
                              rows="4"
                              className="form-control"
                              placeholder="Istruzioni..."
                              required type="text"
                              value={this.state.marksListingInWaitInstructions[item.id]}
                              onChange={(event) => this.onListAsWaitInstructionsChange(event, item)} />
                              {!this.props.marksNotesAddedResults[item.id] && <button onClick={() => this.props.onListAsWaitConfirm(this.state.marksListingInWaitInstructions[item.id], item)} className="btn btn-warning btn-xs btn-update">Invia Istruzioni</button>}
                              {!this.props.marksNotesAddedResults[item.id] && <button onClick={() => { this.onHideListAsWaitMark(item) }} className="btn btn-xs btn-update">Annulla</button>}
                              {this.props.marksNotesAddedResults[item.id] && <span className="text-primary">Nota Inviata Correttamente</span>}
                              {this.props.marksNotesAddedResults[item.id] && <button onClick={() => { this.onHideListAsWaitMark(item); this.props.onCloseWaitConfirm(item) }} className="btn btn-xs btn-update">Chiudi</button>}
                            </div>}
                          </div>
                        </div>
                      </div>}

                    </div>)
                }) : null}
              </div>
            </div>
          </div>
        </div>

        


        <div className="block-info">
          <div className="row">
            <div className="col-md-2">
              <div className="square-box">
                <span className="glyphicon glyphicon-barcode glyphicon-lg">{}</span>
              </div>
            </div>
            <div className="col-md-10">
              <h3 className="title-green">Abbonamenti <span className="margin-span" style={{marginRight: '2rem'}}>{}</span>
                {!this.state.showCreateParkingPass && <a className="btn btn-green" onClick={this.onShowCreateParkingPassClick.bind(this)}>Nuovo Abbonamento</a>}
              </h3>
            </div>
          </div>

          {this.state.showCreateParkingPass &&
          <div className="row">
            <div className="static-modal">
              <div className="my-modal1" style={{display: 'block'}}>
                <div className="modal-dialog" style={{marginTop: '0'}}>
                  <div className="modal-content my-modal2" role="document">
                    <div className="modal-header">
                      <div className="row justify-content-between">
                        <div className="col-md-6">
                          Genera Acquisto Abbonamento:
                        </div>
                        <div className="col-md-offset-11 text-center">
                          {this.state.showCreateParkingPass && <a className="glyphicon glyphicon-remove chiudi-btn" onClick={this.onHideCreateParkingPassClick.bind(this)}>{}</a>}
                        </div>
                      </div>
                    </div>
                    <div className="modal-body">
                      {this.state.showCreateParkingPass && <div className="text-center">
                        <BackOfficeUserDetailParkingPassForm
                          initialValues={{quantity: 1}}
                          parkTicketTypes={this.props.parkTicketTypes}
                          loading={this.props.parkTicketLoading}
                          parkTicketSuccess={this.props.parkTicketSuccess}
                          parkTicketCreateError={this.props.parkTicketError}
                          user={this.props.user}
                          areas={this.props.areas}
                          onSubmit={this.props.onParkingPassSubmit.bind(this)} />
                      </div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }

          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-10">
              <div className="cards-container">
                {this.props.user.parkTickets && this.props.user.parkTickets.map(item => {
                    const filteredZones = item.ParkTicketType.MarkType ? item.ParkTicketType.MarkType.Areas.filter(item => {
                      if (this.props.user.residenceArea) {
                        return item.id === this.props.user.residenceArea.id
                      } else {
                        return item.id === this.props.user.workArea.id
                      }
                    }) : []

                    const zone = filteredZones.length > 0 ? filteredZones[0].code : ''

                    return (
                      <div key={item.id}>
                        <div className={classNames('col-md-6', {'animated flash': highlightObjects.indexOf(`park-ticket-${item.id}`) !== -1})}>
                          <Element name={`park-ticket-${item.id}`} />
                          <div className="card-marks">
                            <div className="caption" style={{padding: 10}}>
                              <h5>ABBONAMENTO <strong>{item.ParkTicketType.printLabel && item.ParkTicketType.printLabel} {!item.ParkTicketType.printLabel && 'STANDARD'}</strong></h5>
                              <h5>
                                <strong>N.</strong> {item.id}
                                {item.ParkTicketType.MarkType && (
                                  <span style={{marginLeft: 15}}>
                            <strong>zona:</strong> {zone}
                          </span>
                                )}
                                {!item.ParkTicketType.MarkType && (
                                  <span style={{marginLeft: 15}}>
                              {item.ParkTicketType.Areas.length > 0 ? (
                                <span><strong>zona:</strong> {item.ParkTicketType.Areas.map(item => item.code + ' ')}</span>
                              ) : (
                                <span><strong>zone:</strong> TUTTE</span>
                              )}
                            </span>
                                )}
                              </h5>
                              {item.markId && <h5><strong>Num. Contrassegno:</strong> {item.markId}</h5>}
                              {item.Vehicles && <h5><strong>Targhe: {item.Vehicles.map((vItem, vIndex) => (<a key={`park-ticket-${item.id}-v${vItem.id}`} href="javascript:void(0);" onClick={() => onVehicleShortLinkClick(vItem)}>{vItem.plate_number + ' '}</a>))}</strong></h5>}
                              {item.Mark && <h5><strong>Targ{item.Mark.Vehicles.length > 1 ? 'he' : 'a'}: {item.Mark.Vehicles.map(item => <a href="javascript:void(0);" onClick={() => onVehicleShortLinkClick(item)}>{item.plate_number}{' '}</a>)}</strong></h5>}
                              <h5><strong>Emesso il:</strong> {moment(item.issuedDate).format('L')}</h5>
                              <h5><strong>Valido dal </strong> {moment(item.startDate).format('L')}<strong> al</strong> {moment(item.endDate).format('L')}
                              </h5>
                              {/* <button type="button" className="btn btn-primary btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-cog">{}</i> Modifica</button>
                                                 <button type="button" className="btn btn-danger btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-ban-circle">{}</i> Cessa</button>
                                                 <button type="button" className="btn btn-danger btn-xs btn-update btn-add-card"><i className="glyphicon glyphicon-trash">{}</i> Elimina</button> */}
                              <a onClick={() => this.props.onDownloadParkTicket(item)} className="btn btn-info-user"><i className="glyphicon glyphicon-download">{}</i> Abbonamento</a>
                              {!item.receiptId && <BackOfficeUserDetailCreateReceiptComponent onSubmit={(method) => { this.props.onIssueReceipt({method: method, parkTicketTypeId: item.parkTicketTypeId, total: item.price, id: item.id}) }} />}
                              {item.receiptId && <a onClick={() => this.props.onReceiptDownload(item.id)} className="btn btn-download-receipt btn-info-user">
                                <i className="glyphicon glyphicon-download">{}</i> Ricevuta</a>}
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                )}
              </div>
            </div>
          </div>
        </div>

        
      </div>

    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/screens/BackOfficeUserDetailScreen.js